import { CloseIcon } from '@chakra-ui/icons';
import {
  Button,
  HStack,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from '@chakra-ui/react';
import React from 'react';

const AddGroupAdminPopup = ({
  MakeGroupAdmins,
  isModal,
  onClose,
  selectedMemberUserName,
}) => {
  const warningText = `As a group admin, ${selectedMemberUserName} will be able to manage who can join and customize this conversation.`;
  return (
    <>
      <Modal isOpen={isModal} closeOnOverlayClick={true} isCentered>
        <ModalOverlay />
        <ModalContent
          backgroundColor="#FFFFFF"
          padding="5px 5px 0px 5px"
          maxWidth="436px"
          borderRadius="16px"
        >
          <ModalHeader>
            <HStack alignItems="center" justifyContent="space-between">
              <Heading
                fontSize="15px"
                fontFamily="Inter"
                lineHeight="18px"
                fontWeight={600}
                color="#5B5B5B"
              >
                Add group admin?
              </Heading>
              <CloseIcon
                width="10px"
                height="10px"
                color="#5B5B5B"
                fontWeight={600}
                onClick={() => onClose()}
              />
            </HStack>
          </ModalHeader>
          <ModalBody>
            <Text maxWidth="388px" w="100%">
              {warningText}
            </Text>
          </ModalBody>
          <ModalFooter>
            <HStack>
              <Button
                backgroundColor="transparent"
                border="1px solid #D9D9D9"
                borderRadius="76px"
                p="9px 18px"
                fontSize="12px"
                fontWeight={500}
                lineHeight="14.4px"
                color="#3D5A80"
                _hover={{
                  backgroundColor: 'transparent',
                }}
                onClick={() => onClose()}
              >
                Cancel
              </Button>
              <Button
                backgroundColor="#3D5A80"
                border="1px solid #D9D9D9"
                borderRadius="76px"
                p="9px 18px"
                fontSize="12px"
                fontWeight={500}
                lineHeight="14.4px"
                color="#FFFFFF"
                _hover={{
                  backgroundColor: '#3D5A80',
                }}
                onClick={() => MakeGroupAdmins()}
              >
                Make Admin
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AddGroupAdminPopup;
